import { getMenu as getMenuRequest } from '../helpers/front-helper'
import { setMenu } from './ui';

export const getMenu = ( token ) => {
    return async ( dispatch ) => {
        let resp = await getMenuRequest( token )
        if(resp.success){
            dispatch( setMenu( resp.data ) )
        }
    }
}

